<template>
  <span class="badge" :class="computedStyleClasses" @click="onClick">
    <ips-icon
      v-if="iconPrepend"
      :icon="iconPrepend"
      class="badge-icon-prepend"
      size="sm"
      @click="prependIconClicked"
    ></ips-icon
    ><slot></slot
    ><ips-icon
      v-if="iconAppend"
      :icon="iconAppend"
      class="badge-icon-append"
      size="sm"
      @click="appendIconClicked"
    ></ips-icon
  ></span>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';

export default {
  name: 'IpsBadge',
  components: { IpsIcon },
  props: {
    variant: {
      name: 'variant',
      description: 'The variant of the badge',
      type: String,
      default: 'gray',
      required: false,
      validator: (value) =>
        ['', 'blue', 'green', 'gray', 'orange', 'purple', 'red', 'teal', 'yellow'].indexOf(
          value
        ) !== -1,
    },
    variantStyle: {
      name: 'variantStyle',
      description: 'The variant style of the badge',
      type: String,
      default: 'solid',
      required: false,
      validator: (value) => ['', 'solid', 'subtle'].indexOf(value) !== -1,
    },
    iconPrepend: {
      name: 'iconPrepend',
      description: 'The icon to prepend to the badge',
      type: String,
      default: '',
      required: false,
    },
    iconAppend: {
      name: 'iconAppend',
      description: 'The icon to append to the badge',
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    computedVariant() {
      switch (this.variant) {
        case 'blue':
          return 'badge-blue';
        case 'green':
          return 'badge-green';
        case 'orange':
          return 'badge-orange';
        case 'purple':
          return 'badge-purple';
        case 'red':
          return 'badge-red';
        case 'teal':
          return 'badge-teal';
        case 'yellow':
          return 'badge-yellow';
        case 'gray':
        default:
          return 'badge-gray';
      }
    },
    computedStyleClasses() {
      return `${this.computedVariant}-${this.variantStyle}`;
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
    appendIconClicked(event) {
      this.$emit('append-icon-clicked', event);
    },
    prependIconClicked(event) {
      this.$emit('prepend-icon-clicked', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-icon-prepend {
  padding-right: 0.5rem;
}
.badge-icon-append {
  padding-left: 0.5rem;
}
</style>
